import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Lookbook = ({ leftImage, label, title, products = [] }) => {
  const swiperRef = useRef(null);

  useEffect(() => {
    const initializeSwiper = () => {
      if (!window.Swiper || !swiperRef.current) {
        setTimeout(initializeSwiper, 100);
        return;
      }

      if (swiperRef.current.swiper) {
        try {
          swiperRef.current.swiper.destroy(true, true);
        } catch (e) {
          // no-op
        }
      }

      const nextEl = document.querySelector(".nav-next-lookbook");
      const prevEl = document.querySelector(".nav-prev-lookbook");

      new window.Swiper(swiperRef.current, {
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        pagination: {
          el: ".sw-pagination-lookbook",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 15,
          },
          1150: {
            slidesPerView: 1,
            spaceBetween: 30,
          },
        },
      });
    };

    initializeSwiper();

    return () => {
      if (swiperRef.current && swiperRef.current.swiper) {
        try {
          swiperRef.current.swiper.destroy(true, true);
        } catch (e) {
          // no-op
        }
      }
    };
  }, [products]);

  return (
    <section className="flat-spacing-15 pt_0">
      <div className="container">
        <div className="flat-lookbook-v2">
          <div className="col-left">
            <div className="wrap-lookbook lookbook-sw radius-10 o-hidden">
              <Link to="/shop/default?offer_id=710" className="image">
                <img
                  className="lazyload"
                  data-src={leftImage}
                  src={leftImage}
                  alt="collection-img"
                />
              </Link>
              <div className="navigation-sw-dot nav-next-lookbook">
                <span></span>
              </div>
              <div className="navigation-sw-dot nav-prev-lookbook">
                <span></span>
              </div>
            </div>
          </div>
          <div className="col-right type-1">
            <div className="slider-wrap-lookbook">
              <div className="nav-sw nav-next-slider nav-next-lookbook">
                <span className="icon icon-arrow-left"></span>
              </div>
              <div className="inner-sw-lookbook">
                {(label || title) && (
                  <div className="flat-title-lookbook">
                    {label && <p className="label">{label}</p>}
                    {title && <h3 className="heading">{title}</h3>}
                  </div>
                )}
                <div
                  dir="ltr"
                  ref={swiperRef}
                  className="swiper tf-sw-lookbook wrap-sw-over"
                  data-preview="1"
                  data-tablet="1"
                  data-mobile="1"
                  data-space-lg="30"
                  data-space-md="15"
                >
                  <div className="swiper-wrapper">
                    {products.map((product, index) => (
                      <div key={index} className="swiper-slide" lazy="true">
                        <div className="card-product">
                          <div className="card-product-wrapper">
                            <Link
                              to="/shop/default?offer_id=710"
                              className="product-img"
                            >
                              <img
                                className="lazyload img-product"
                                data-src={product.image}
                                src={product.image}
                                alt={product.name || "image-product"}
                              />
                              <img
                                className="lazyload img-hover"
                                data-src={product.hoverImage || product.image}
                                src={product.hoverImage || product.image}
                                alt={product.name || "image-product"}
                              />
                            </Link>
                            <div className="list-product-btn absolute-2">
                              <a
                                href="#quick_add"
                                data-bs-toggle="modal"
                                className="box-icon bg_white quick-add tf-btn-loading"
                              >
                                <span className="icon icon-bag"></span>
                                <span className="tooltip">Quick Add</span>
                              </a>
                              <a
                                href="javascript:void(0);"
                                className="box-icon bg_white wishlist btn-icon-action"
                              >
                                <span className="icon icon-heart"></span>
                                <span className="tooltip">Add to Wishlist</span>
                                <span className="icon icon-delete"></span>
                              </a>
                              <a
                                href="#compare"
                                data-bs-toggle="offcanvas"
                                aria-controls="offcanvasLeft"
                                className="box-icon bg_white compare btn-icon-action"
                              >
                                <span className="icon icon-compare"></span>
                                <span className="tooltip">Add to Compare</span>
                                <span className="icon icon-check"></span>
                              </a>
                              <a
                                href="#quick_view"
                                data-bs-toggle="modal"
                                className="box-icon bg_white quickview tf-btn-loading"
                              >
                                <span className="icon icon-view"></span>
                                <span className="tooltip">Quick View</span>
                              </a>
                            </div>
                          </div>
                          <div className="card-product-info">
                            <Link
                              to="/shop/default?offer_id=710"
                              className="title link"
                            >
                              {product.name}
                            </Link>
                            <span className="price">{product.price}</span>
                            {product.colors && product.colors.length > 0 && (
                              <ul className="list-color-product">
                                {product.colors.map((color, colorIndex) => (
                                  <li
                                    key={colorIndex}
                                    className={`list-color-item color-swatch ${
                                      colorIndex === 0 ? "active" : ""
                                    }`}
                                  >
                                    <span className="tooltip">
                                      {color.name}
                                    </span>
                                    <span
                                      className={`swatch-value ${
                                        color.className || ""
                                      }`}
                                    ></span>
                                    {color.image && (
                                      <img
                                        className="lazyload"
                                        data-src={color.image}
                                        src={color.image}
                                        alt={color.name}
                                      />
                                    )}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="sw-dots style-2 sw-pagination-lookbook d-md-none"></div>
                </div>
              </div>
              <div className="nav-sw nav-prev-slider nav-prev-lookbook">
                <span className="icon icon-arrow-right"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Lookbook;
